import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const AMMAN_TZ = 'Asia/Amman';

export const formatAmmanDateTime = (
  value: string | Date | null | undefined,
  format = 'YYYY-MM-DD HH:mm'
): string => {
  if (!value) return '—';
  return dayjs.utc(value).tz(AMMAN_TZ).format(format);
};
